import {Option} from "react-multi-select-component/dist/lib/interfaces";
import {AuthInfo, IndexWord, Word} from "../models/models";



export interface StoreState {
	authInfo: AuthInfo | null
	indexWords: Record<number, IndexWord>
	indexWordsCount: number
	printWords: Word[]
	selectedSearchDictionaryGroups: Option[]
}



export const initialState: StoreState = {
	authInfo: null,
	indexWords: {},
	indexWordsCount: 0,
	printWords: [],
	selectedSearchDictionaryGroups: []
};